const namespace = 'retailer_dashboards';
export const SET_TYPE = `${namespace}_SET_TYPE`;
export const SET_SUBTYPE = `${namespace}_SET_SUBTYPE`;
export const CLEAR_RETAILER_DASHBOARDS = `${namespace}_CLEAR_RETAILER_DASHBOARDS`;

export const setType = (type) => ({
  type: SET_TYPE,
  payload: type,
});

export const setSubType = (subtype) => ({
  type: SET_SUBTYPE,
  payload: subtype,
});

export const setDashboardSubtype = (subtype) => (dispatch) => {
  dispatch(setSubType(subtype));
};

export const clearRetailerDashboards = () => ({
  type: CLEAR_RETAILER_DASHBOARDS,
});



// WEBPACK FOOTER //
// ./src/modules/retailer-dashboards/actions/retailer-dashboards.actions.js